import isPlainObject from 'lodash/isPlainObject'
import isArray from 'lodash/isArray'
import reduce from 'lodash/reduce'
import merge from 'lodash/merge'
import toPairs from 'lodash/toPairs'

export function flattenObject(
  obj: any, // eslint-disable-line @typescript-eslint/no-explicit-any
  path: string[] = []
): Record<string, string | number | null> {
  if (isPlainObject(obj) || (isArray(obj) && obj.some((item) => isPlainObject(item)))) {
    return reduce(toPairs(obj), (acc, [k, v]) => merge(acc, flattenObject(v, [...path, k])), {})
  }

  return {
    [path.join('.')]: obj,
  }
}
